import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, CloseButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import adaswaplogo from "../assets/images/adaswaplogo.png";
import adaswaplogo2 from "../assets/images/adaswaplogo2.png";
import iconT from "../assets/images/tet.png";
import "./LiquidityModel.css";

function LiquidityModel() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-create-wraper">
	  <Button className="liquidityButton transition" onClick={handleShow}>
					<span className="d-flex gap-3">
						<span className="plus-icon">
							<FontAwesomeIcon icon={faPlus} />
						</span>
						Add Liquidity
					</span>
				</Button>
        <Modal show={show} onHide={handleClose} className="add-liquidity-modal">
          <Modal.Header>
            <Modal.Title className="text-white text-center d-flex justify-content-center">
              Add Liquidity
            </Modal.Title>
            <CloseButton variant="white" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body className="pair---create-model">
            <div className="d-flex">
              <div className="liquidity-provider">
                <h6>You are the first liquidity provider</h6>
                <p>
                  The ratio of tokens you add will set the price. Once you are
                  ok with the rate click supply to review.
                </p>
              </div>
            </div>
            <div className="swapPage-content">
              <div className="swap-farm-fields">
                <div className="field-one-iner d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <div className="field-one">
                      <h2>Input</h2>
                    </div>
                    <div className="d-flex">
                      <h3>0.0</h3>
                    </div>
                    <div className="field-one">
                      <h2>Balance: 2.4000</h2>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="max-text me-2 me-md-4">Max</span>
                    <div className="d-flex right-ada align-items-center">
                      <span className="adaswaplogo">
                        <img src={adaswaplogo} alt="" />
                      </span>
                      <h3>Ada</h3>
                      <FontAwesomeIcon icon={faChevronDown} className="ms-2 angle-down text-white"/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center box-two">
                <div className="arrow-down-circle">
                  <a href="#" target="_blank">
                    <FontAwesomeIcon icon={faPlus} />
                  </a>
                </div>
              </div>
			  <div className="swap-farm-fields">
                <div className="field-one-iner d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <div className="field-one">
                      <h2>Input</h2>
                    </div>
                    <div className="d-flex">
                      <h3>0.0</h3>
                    </div>
                    <div className="field-one">
                      <h2>Balance: 2.4000</h2>
                    </div>
                  </div>
				          <div className="d-flex align-items-center">
                    <span className="max-text me-2 me-md-4">Max</span>
                    <div className="d-flex right-ada align-items-center">
                      <span className="adaswaplogo">
                        <img src={iconT} alt="" />
                      </span>
                      <h3>USDT</h3>
                      <FontAwesomeIcon icon={faChevronDown} className="ms-2 angle-down text-white"/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center box-two">
                <div className="d-flex">
                  <h2>Prices and Pool</h2>
                </div>
              </div>
              <div className="d-flex align-items-center text-white text-center mb-4 stats-row">
                <div className="stat-col">
                  <strong className="stat-value d-block mb-2">976.17</strong>
                  <span className="stat-name d-block">USDT per CAO</span>
                </div>
                <div className="stat-col">
                  <strong className="stat-value d-block mb-2">0.0010244</strong>
                  <span className="stat-name d-block">CAO per</span>
                </div>
                <div className="stat-col">
                  <strong className="stat-value d-block mb-2">&lt;0.01</strong>
                  <span className="stat-name d-block">Share of pool</span>
                </div>
              </div>
              <div className="mb-4">
                <Link
                  to=""
                  className="d-block btn-supply text-center transition"
                >
                  Supply
                </Link>
              </div>
              <div className="text-white note-text text-center">
                <p>
                  When you add liquidity, you will receive pool tokens
                  representing your position. These tokens automatically earn
                  fees proportional to your share of the pool, and can be
                  redeemed at any time.
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default LiquidityModel;
